import React from 'react';
import styled from '@emotion/styled';
import { Box } from '../Rebass';
import Text from '../Text';
import theme from '../../theme';
import { MetaProps } from './types';
// import Link from 'gatsby-link';
// Breaks in dev branch
// import { Link } from 'gatsby';

const MetaSeparator = styled(Box)`
  display: inline-block;
  height: 4px;
  width: 4px;
  background-color: ${({ color }: { color: string }) => color};
  border-radius: 50%;
  margin: 0 ${theme.space[1]}px;
  margin-bottom: 3px;
`;

const MetaContainer = styled(Box)`
  line-height: 1;
`;

const Meta = ({ meta, size }: MetaProps) => (
  <MetaContainer>
    {meta.map((item, idx) => {
      return (
        <Box sx={{ display: 'inline-block' }} key={idx}>
          {/* {item.type === 'link' ? (
            <Link to={item.to}>
              <Text size={size} color={item.color}>
                {item.text}
              </Text>
            </Link>
          ) : ( */}
          <Text size={size} color={item.color}>
            {item.text}
          </Text>
          {/* )} */}

          {idx !== meta.length - 1 && (
            <MetaSeparator color={theme.colors.baseBlack} />
          )}
        </Box>
      );
    })}
  </MetaContainer>
);

Meta.defaultProps = {
  size: 'small',
  meta: [],
  type: '',
};

export default Meta;
